export const Loading3Icon = ({
  width = 40,
  height = 40,
  title = "Loading",
  ...rest
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    {...rest}>
    <title>{title}</title>
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M27.815 7.098h-.943a4.444 4.444 0 0 0-4.444 4.445v16.835a4.445 4.445 0 0 0 4.444 4.444h.943a4.445 4.445 0 0 0 4.444-4.444V11.543a4.444 4.444 0 0 0-4.444-4.445Z"
    />
    <path
      fill="#5DCDFF"
      d="M27.411 14.034a1.784 1.784 0 1 0 0-3.568 1.784 1.784 0 0 0 0 3.568Z"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M27.781 24.62h-.942c-1.19 0-2.155.965-2.155 2.155v1.078c0 1.19.964 2.155 2.154 2.155h.943c1.19 0 2.155-.965 2.155-2.155v-1.078c0-1.19-.965-2.154-2.155-2.154Z"
    />
    <path
      fill="#5DCDFF"
      d="M12.656 19.368a1.434 1.434 0 1 0 0-2.868 1.434 1.434 0 0 0 0 2.868Z"
    />
    <path
      fill="#00226A"
      d="M12.63 26.371a.606.606 0 1 0 0-1.212.606.606 0 0 0 0 1.212Z"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M12.656 20.59a2.629 2.629 0 1 0 0-5.256 2.629 2.629 0 0 0 0 5.257Z"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M13.493 12.769H11.82a3.943 3.943 0 0 0-3.943 3.943v7.766a3.943 3.943 0 0 0 3.943 3.943h1.673a3.943 3.943 0 0 0 3.943-3.943v-7.767a3.943 3.943 0 0 0-3.943-3.942Z"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="m11.711 29.86-.39-1.44h2.629l-.406 1.445a.478.478 0 0 1-.46.348h-.911a.478.478 0 0 1-.462-.353ZM12.537 30.273c-1.738 0-3.494 1.006-4.625 1.874-.337.26-.143.755.282.755h8.726c.429 0 .622-.5.28-.758-1.15-.868-2.927-1.871-4.663-1.871Z"
    />
  </svg>
);
